<script lang="ts" setup>
const props = defineProps<{ linkId: string }>();

const emit = defineEmits<{
  (e: 'cancel'): void;
}>();

const router = useRouter();
const message = useAlerts();

async function copyProjectLink() {
  await navigator.clipboard
    .writeText(`${window.location.origin}/projects/${props.linkId}`)
    .then(() => {
      message.success($t('message.copiedSuccessfully', { item: 'link' }));
    });
}

async function goToProject() {
  await router.push({
    name: 'ProjectPage',
    params: {
      projectId: props.linkId,
    },
  });
  emit('cancel');
}
</script>

<template>
  <div>
    <div class="icon-container">
      <UiIcon name="Check" :size="25" class="check-icon" />
    </div>

    <h1>{{ $t('project.projectCreatedTitle') }}</h1>

    <UiField :label="$t('project.shareLink')">
      <div class="copy-input-container">
        <input
          ref="copyInputRef"
          readonly
          :value="props.linkId"
          class="copy-input"
        />
        <button class="copy-btn" @click="copyProjectLink">
          <UiIcon name="Copy" :size="25" class="copy-icon" />
        </button>
      </div>
    </UiField>

    <UiButtonRow
      expand
      class="button-row"
      :cancel-button-text="$t('button.close')"
      :action-button-text="$t('project.goToProject')"
      @cancel="emit('cancel')"
      @action="goToProject"
    />
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-18);
  line-height: var(--line-height-28);
  color: var(--color-gray-900);
  margin: var(--space-8) 0;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: px(56);
  height: px(56);
  background: var(--color-primary-50);
  border: px(1.5) solid var(--color-primary-100);
  border-radius: px(44);
  margin: auto;
  color: var(--color-gray-900);
}

.copy-btn {
  background: transparent;
  cursor: pointer;
}

.check-icon {
  color: var(--color-primary-500);
}
.subtitle {
  color: var(--color-gray-500);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
}

.copy-icon {
  color: var(--color-gray-300);
}

.copy-input {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: stretch;
  padding: var(--space-8) var(--space-16);
  gap: var(--space-8);
  width: 100%;
  height: px(44);
  align-self: stretch;
  border: 1px solid var(--color-gray-300);
  background: #ffffff;
  box-shadow: var(--shadow-xs);
}

.copy-input-container {
  display: flex;
  align-items: center;
  gap: var(--space-8);
}

.button-row {
  margin-top: var(--space-24);
}
</style>
